import type React from 'react';

import { observer } from 'mobx-react';

import { TextField } from '@material-ui/core';

import { useAction } from 'bz-utilities/hooks/action';

import { useAddStore } from '../../stores/add-store';

export interface IProps {
  route: string;

  onBlur?: () => void;
}

const AddControlInput: React.FC<IProps> = observer(({ route, onBlur: pOnBlur }) => {
  const addStore = useAddStore();

  const { description } = addStore;

  const onBlur = useAction((): void => {
    if (addStore.description.trim() !== '') {
      return;
    }
    pOnBlur?.();
  }, [addStore, pOnBlur]);

  const onChange = useAction(
    (e: React.ChangeEvent<HTMLInputElement>): void => {
      addStore.description = e.target.value;
    },
    [addStore]
  );

  return (
    <TextField
      id={route}
      placeholder="New Item"
      value={description}
      onBlur={onBlur}
      onChange={onChange}
    />
  );
});

AddControlInput.displayName = 'AddControlInput';

export default AddControlInput;
